exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".gwnl-dept-cell[data-v-5b4ed05d]{width:100%}.gwnl-dept-cell__label[data-v-5b4ed05d]{max-width:100%}\n", ""]);

